import {UserInfoState} from './user-info.type';
import {createStore, withProps} from '@ngneat/elf';

export interface UserInfo {
  userInfo: UserInfoState;
}

export function createInitialState(): UserInfoState {
  return {
    affiliateAccepted: false,
    aiPaidUser: false,
    discount: '',
    discount_expires_at: '',
    siteCreateOnTunings: {enabled: false},
    totalSitesLoads: 0,
    accountCode: '',
    targetAccountCode: '',
    agencyMode: false,
    isPartner: false,
    agencyAccount: null,
    firstName: '',
    lastName: '',
    removedSitesCount: '',
    sitesCount: 0,
    id: '',
    username: '',
    is_feedback_submitted: null,
    is_feedback_trustpilot_submitted: null,
    is_feedback_g2_submitted: null,
    userStatus: null,
    siteCreateOnTuningsEnabled: null,
    siteCreateReviewList: false,
    walkthroughStatus: null,
    open_regulation_tracker: false,
    code: null,
    isFixMyCodeEnabled: false,
    trialInfo: {
      isTrialNoCard: false,
      isTrialNoCardWelcomeScreenShow: false,
      isTrialNoCardExpired: false,
    },
  };
}

export const userInfoStore = createStore(
  {name: 'user-info'},
  withProps<UserInfo>({
    userInfo: createInitialState(),
  }),
);
